import { Modal } from 'antd'
import type { FtpVersionsState } from './types'
import { formatDate } from './utils'
import styles from './FtpClient.module.css'

interface FtpVersionsModalProps {
  state: FtpVersionsState | null
  loading: boolean
  onClose: () => void
  onRestore: (index: number) => void
  onPreview: (content: string) => void
}

export function FtpVersionsModal({
  state,
  loading,
  onClose,
  onRestore,
  onPreview,
}: FtpVersionsModalProps) {
  return (
    <Modal
      title={state ? `Версии: ${state.fileName}` : 'Версии файла'}
      open={!!state}
      onCancel={onClose}
      footer={null}
      width={720}
      destroyOnHidden
    >
      {loading ? (
        <p>Загрузка…</p>
      ) : !state?.versions.length ? (
        <p className={styles.mutedText}>Сохранённые версии отсутствуют (создаются при редактировании файла).</p>
      ) : (
        <div className={styles.versionsList}>
          {state.versions.map((v, index) => (
            <div key={v.timestamp} className={styles.versionRow}>
              <div className={styles.versionMeta}>
                <strong>Версия {state.versions.length - index}</strong>
                <span>{formatDate(new Date(v.timestamp).toISOString())}</span>
                <span>{v.content.length} символов</span>
              </div>
              <div className={styles.versionActions}>
                <button type="button" className={styles.btnSecondary} onClick={() => onPreview(v.content)}>
                  Просмотр
                </button>
                <button type="button" className={styles.btnPrimary} onClick={() => onRestore(index)}>
                  Восстановить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Modal>
  )
}
